import React from 'react';
import { Handle, Position } from 'reactflow';
import { Wrench, Zap, Globe, Box, X, Play, Loader, AlertCircle } from 'lucide-react';

const SOURCE_ICONS = {
  builtin:  <Zap size={13} />,
  platform: <Globe size={13} />,
  org:      <Box size={13} />,
};

// status: idle | running | done | error
const ToolNode = ({ data }) => {
  const status = data.runStatus || 'idle';
  const isRunning = status === 'running';

  return (
    <div className={`tool-node tool-node--${status}`}>
      <div className="tool-node-controls">
        <button
          className="delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            if (window.confirm('Remove this tool node?')) {
              data.onDelete && data.onDelete();
            }
          }}
        >
          <X size={11} />
        </button>
      </div>

      <Handle type="target" position={Position.Top} style={{ backgroundColor: '#6366f1' }} />

      <div className="tool-node-icon">
        {SOURCE_ICONS[data.source] || <Wrench size={14} />}
      </div>
      <div className="tool-node-name">{data.name || data.title || 'Tool'}</div>
      {data.description && (
        <div className="tool-node-desc">{data.description}</div>
      )}
      <div className="tool-node-badge">{data.slug || data.tool_type || 'tool'}</div>

      {/* Status feedback */}
      {status === 'error' && data.runError && (
        <div className="tool-node-error">
          <AlertCircle size={11} /> {data.runError}
        </div>
      )}

      {/* Run button */}
      <button
        className="tool-node-run"
        disabled={isRunning}
        title={isRunning ? 'Running…' : 'Run tool with upstream input'}
        onClick={(e) => {
          e.stopPropagation();
          data.onRun && data.onRun();
        }}
      >
        {isRunning
          ? <><Loader size={12} className="spin" /> Running…</>
          : <><Play size={12} /> Run</>
        }
      </button>

      <Handle type="source" position={Position.Bottom} style={{ backgroundColor: '#6366f1' }} />
    </div>
  );
};

export default ToolNode;
